<template>
  <main class="px-5 py-4">
    <b-card class="cardStyle" no-body>
      <section>
        <manage-access-filters :userFilter.sync="userFilter" @filter="filter" />
      </section>

      <section>
        <team-members-table
          :currentPage.sync="currentPage"
          :filter="userFilter"
          :loading="loading"
          :perPage="perPage"
          :teamMembers="teamMembers"
          :totalRows.sync="totalRows"
        />
      </section>
    </b-card>
    <section>
      <manage-access-footer
        v-if="!loading && teamMembers.length > 0"
        :currentPage.sync="currentPage"
        :perPage="perPage"
        :totalRows="totalRows"
      />
    </section>
  </main>
</template>

<script>
  import ManageAccessFilters from './ManageAccessFilters';
  import ManageAccessFooter from './ManageAccessFooter';
  import TeamMembersTable from './TeamMembersTable';
  import _ from 'lodash';

  export default {
    name: 'manage-access',
    components: { ManageAccessFilters, TeamMembersTable, ManageAccessFooter },
    props: {
      user: Object,
    },
    data() {
      return {
        userFilter: '',
        loading: false,
        teamMembers: [],
        totalRows: 0,
        perPage: 10,
        currentPage: 1,
        hasOversightPermission: false,
      };
    },
    created() {
      this.getMembers({
        participant_email: this.canSeeSiteTeamMembers ? '' : window['Laravel']['user_email'],
      });
    },
    computed: {
      canSeeSiteTeamMembers() {
        this.hasOversightPermission = this.user.permissions.some(
          p => p.name === 'access enrollment oversight',
        );
        return this.hasOversightPermission && !this.user.exostarId;
      },
    },
    methods: {
      filter(payload) {
        let params = {
          study: payload.study,
          site: payload.site,
          name: payload.name,
          participant_email: this.canSeeSiteTeamMembers ? '' : window['Laravel']['user_email'],
        };
        this.getMembers(params);
      },
      async getMembers(params) {
        this.loading = true;
        try {
          this.teamMembers = [];
          this.totalRows = 0;
          this.currentPage = 1;
          let response = await axios.get(`/api/get-site-team`, {
            params: params,
          });
          if (response.status !== 204) {
            this.teamMembers = response.data['items'].map(element => {
              return {
                firstName: element['firstName'],
                lastName: element['lastName'],
                fullName: element['name'],
                emails: element['emails'],
                phoneNumber: '',
                roles: element['roles'],
                ordering: element['ordering'],
                selectedEmail: element['emails'].length > 0 ? element['emails'][0] : null,
                personId: element['personID'],
                studyId: element['studyId'],
                siteNumber: element['siteNumber'],
              };
            });
            this.teamMembers = _.orderBy(this.teamMembers, 'ordering', 'asc');
          }
        } catch (error) {
          console.error(error);
        }
        this.loading = false;
      },
    },
  };
</script>
